import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
function DeactiveCustomer() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [deactiveCode, DeactiveCustomer] = useState([]);
    const [networkName, setNetworkName] = useState([]);
    const [streetName, setStreetName] = useState([]);
    const [staffCode, setStaffCode] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ deactive_reason: "", network: "", date: "", toDate: "" })
    const initialFormData = { deactive_reason: "", network: "", date: "", toDate: "" }
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
     const downloadCSV = () => {
  const headers = [
    "Sno", "Customer_Name", "Acc_no", "Code", "STB_no", "Door_no", "Flat_name",
    "Street_name", "Phone", "Pay_Status", "Plan_Amount", "Paid_Amount", "Paid_Date",
    "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
    "Staff_Code", "Network", "Paid_time", "Package", "Added_date", "Collection_Staff"
  ];

  const csvRows = [];
  csvRows.push(headers.join(",")); // header row


     allCustomer.forEach((row, index) => {
    const values = [
      index + 1, 
      row.name,
      row.account_num,
      row.acc_num,
      row.serial_num,
      row.doorno,
      row.flat_name,
      row.street,
      row.mobile,
      row.status,
      row.pay_amt,
      row.paid_amt,
      row.paid_date,
      row.balance_amt,
      row.discount,
      row.extra_balance_amt,
      row.pend_amt,
      row.area_code,
      row.net_name,
      row.paid_time,
      row.package,
      row.adate,
      row.col_boy
    ];

    // Properly escape and wrap every value
    const safeValues = values.map(v => {
      const str = v == null ? "" : String(v).replace(/"/g, '""'); // escape quotes
      return `"${str}"`; // wrap with double quotes
    });

    csvRows.push(safeValues.join(","));
  });

  const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "DeactiveCustomers.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allCustomer.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(allCustomer.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const handleClear = () => { setFormData(initialFormData); };
    function handleSubmit(e) {
        setIsButtonDisabled(true);
        e.preventDefault();
        console.log("Form Data:", formData); a();
        async function a() {
            try {
                const response = await axios.post('https://node.cabletvpay.in/deactiveCustomerSpecific', { user, formData });
                if (response.status === 200) {
                    console.log(response.data.result);
                    setStbCount(response.data.result.length);
                    setAllCustomer(response.data.result);
                    setIsButtonDisabled(false);
                }
            } catch (err) {
                toast.error(err.response?.data?.message || "Error fetching data");
                setIsButtonDisabled(false)
            }
        }
    }
    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/deactiveCustomerGetInfo', { user });
            if (response.status === 200) {
                setNetworkName(response.data.net_name);
                setStbCount(response.data.allCustomer.length);
                setStaffCode(response.data.staffCode);
                setStreetName(response.data.streetDetails);
                setAllCustomer(response.data.allCustomer);
                DeactiveCustomer(response.data.deactiveCode);
            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };
    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);
    const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
    useEffect(() => { fetchUserData(); }, []);
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
          <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
        </div></div>);
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
               <h5 className='h5'>DEACTIVE CUSTOMER DETAILS</h5><hr className='mt-0' />
                                   <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                <div className="mt-3 mb-2 mb-lg-5">
                    <div className="card  border-0 px-1">

                        <form method="get" onSubmit={handleSubmit}>
                            <div className="row mx-3 d-flex justify-content-center">



                                <div className="col-lg-2 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="date" className="text-center valuesDec text-navy">Date</label>
                                        <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" value={formData.date} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                                        <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate" value={formData.toDate} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="area_code" className="text-center valuesDec text-navy">Deactive Reason</label>
                                        <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="deactive_reason" name="deactive_reason" value={formData.deactive_reason} onChange={handleChange}>
                                        <option className='bg-light' value="none">none</option>
                                        {deactiveCode.length > 0 ? (deactiveCode.map((row, index) => (
                                                <option className='bg-light' key={index} value={row.deactive_reason}>
                                                    {row.deactive_reason}
                                                </option>
                                            ))) : (<option className='bg-light' value="">No staff codes available</option>)}
                                        </select>
                                    </div> {/* form-group */}
                                </div>{/* column */}
                                <div className="col-lg-2 col-md-3 mt-md-2 pt-2 pt-md-4 col-6 mb-2 d-flex justify-content-center">
                                    <input type="submit" className="btn border-0 h-75 bg-info filterBtn text-light pb-3 pb-lg-1 w-100" disabled={isButtonDisabled} value="Filter" />
                                </div>
                                <div className="col-lg-1 col-md-3 mt-md-2 pt-2 pt-md-4 col-6 mb-2 d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className="btn border-0 bg-danger filterBtn text-light h-75 pb-3 pb-lg-1 w-100"
                                        onClick={handleClear}
                                    >
                                        Clear
                                    </button>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>

                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            {/* Header Title */}
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="col-lg-8 mt-1">
                                <span><div className="row w-auto">
                                    <div className="col-11 col-lg-6">
                                        <div className="input-group">
                                            <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                            <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                        <div className="d-flex justify-content-end">
                                            <div className=" btn-group">
                                                <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>
                                                 <button type="button" className="btn btn-dark border-left px-lg-3 px-5 my-1 d-flex" data-toggle="modal" onClick={handleCopyToClipboard} data-target="#exampleModal"> <i className="far fa-copy pt-1 px-1" /> STBCOPY-{stbCount} </button>
                                            </div>
                                        </div>
                                    </div>
                                </div></span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <table id="myTable" className="table table-bordered  table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    {/* Table headers with sorting functionality */}
                                    <th>Sl_No</th>

                                    <th>
                                        Customer__Name
                                    </th>
                                    <th>Acc_no</th>
                                    <th>Code</th>
                                    <th>STB_no</th>
                                    <th>D_no</th>
                                    <th>Flat_name</th>
                                    <th>Street__name</th>
                                    <th>Phone</th>
                                    <th>Pay Status</th>
                                    <th>Plan Amount</th>

                                    <th>Staff__Code</th>
                                    <th>Networks</th>

                                    <th>Packages</th>
                                    <th>Date</th>
                                    <th>Connection Status</th>
                                    <th>Deactive Reason</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index} style={{ backgroundColor: row.status === "unpaid" ? "#ffcccb" : "#dbffdb" }}>
                                            <td className='tableText border-dark text-bold'>{indexOfFirstRow + index + 1}</td>


                                            <td className='tableText border-dark text-bold'><Link to="/customerHistory">{row.name}</Link></td>
                                            <td className='tableText border-dark text-bold'>{row.account_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.acc_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.serial_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.doorno}</td>
                                            <td className='tableText border-dark text-bold'>{row.flat_name}</td>
                                            <td className='tableText border-dark text-bold'>{row.street}</td>
                                            <td className='tableText border-dark text-bold'>{row.mobile}</td>
                                            <td className='tableText border-dark text-bold'>{row.status}</td>
                                            <td className='tableText border-dark text-bold'>{row.pay_amt}</td>

                                            <td className='tableText border-dark text-bold'>{row.area_code}</td>
                                            <td className='tableText border-dark text-bold'>{row.net_name}</td>

                                            <td className='tableText border-dark text-bold'>{row.package}</td>
                                            <td className='tableText border-dark text-bold'>{row.dactive_date}</td>
                                            <td className='tableText border-dark text-bold'>
                                                {row.con_status === "active" || row.con_status === "Active" ? (
                                                    <button className="btn btn-success">A</button>
                                                ) : row.con_status === "deactive" || row.con_status === "Deactive" ? (
                                                    <div className="d-flex-column"><button className="btn btn-danger">Deactive </button></div>
                                                ) : (
                                                    <div className="d-flex-column"><button className="btn btn-secondary">{row.con_status}</button></div>
                                                )}
                                            </td>
                                            <td className='tableText border-dark text-bold'>{row.deactive_reason}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                     <div className="card-footer">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
             
            </div>
        </div>
    );
}

export default DeactiveCustomer;
